import React from 'react';
import service from "../../../service/service";
import DownloadReport from "../DownloadReport";

export default function UnusedAmiDownloadReport() {
    const apiCallFunction = service.monitoring().downloadAmi
    return <DownloadReport downloadFunction={apiCallFunction} title={'Download unused AMI report'}/>
}